import type { EventItem, FaqItem } from '@/types';

export const events: EventItem[] = [
  {
    slug: 'canyin-pingtai-huishou',
    title: '某网红餐饮品牌加盟合同「阴阳条款」争议',
    tagline: '博主曝合同细节与承诺不符，补档多份签约记录与口头承诺录音',
    category: '商业纠纷',
    status: '持续更新',
    persons: ['餐饮加盟商当事人(化名)'],
    time: '2026-08-18',
    heat: 9.6,
    cover: 'https://readdy.ai/api/search-image?query=vintage%20business%20contract%20documents%20and%20signed%20agreements%20collage%20on%20warm%20paper%2C%20vermilion%20red%20stamp%20marks%2C%20archival%20documentary%20aesthetic%2C%20high%20contrast%20editorial%20scan&width=900&height=1200&seq=ev-doc-2026&orientation=portrait',
    dominantType: 'doc',
    summary: '当事人公开多份加盟合同对比截图与沟通录音，称品牌方宣传与合同实际条款存在出入，双方各执一词。',
    paragraphs: [
      '事件起因是某博主公开一段签约沟通录音，称招商人员在口头承诺中给出的回本周期、区域保护等条件，未完整写入最终合同，形成所谓「阴阳条款」。',
      '随后多位已加盟商家陆续在评论区与社媒补充其签约经历，69爆料已按时间顺序归拢聊天截图与合同关键页对比，供各方自行核验。',
      '截至本档案更新，品牌方尚未就合同条款差异作出正式回应，本条目状态标记为持续更新，仅汇总已公开材料，不作倾向性结论。',
    ],
    materials: [
      { type: 'audio', title: '签约沟通录音(部分节选)', note: '约6分钟录音，涉及回本周期与区域保护口头承诺。', source: '当事人提供(已脱敏)', time: '2026-07-30', verified: true },
      { type: 'chat', title: '招商沟通聊天记录', note: '多屏聊天截图，含宣传话术与费用明细。', source: '社媒公开帖', time: '2026-08-01', verified: true },
      { type: 'doc', title: '两份合同关键条款对比表', note: '由网友整理并标注差异项。', source: '热心网友整理', time: '2026-08-09', verified: false },
    ],
    timeline: [
      { time: '2026-07-30', text: '当事人在社媒发布首段录音与求助帖。' },
      { time: '2026-08-01', text: '多张聊天截图在吃瓜社区流传。' },
      { time: '2026-08-09', text: '网友整理合同条款对比表补档。' },
      { time: '2026-08-18', text: '新增商家的补充证据，条目升级为持续更新。' },
    ],
    related: ['xuetang-gaokao-kecheng', 'shentou-peixun-muwang'],
  },
  {
    slug: 'xuetang-gaokao-kecheng',
    title: '高考志愿「包过」辅导课程退费纠纷',
    tagline: '家长曝「保录取」宣传截图，机构称系个人话术',
    category: '教育培训',
    status: '辟谣中',
    persons: ['家长当事人(化名)', '某志愿填报机构'],
    time: '2026-08-02',
    heat: 8.9,
    cover: 'https://readdy.ai/api/search-image?query=archival%20scan%20of%20messaging%20app%20chat%20bubbles%20printed%20on%20warm%20cream%20paper%2C%20grainy%20documentary%20aesthetic%2C%20subtle%20vermilion%20accent%2C%20editorial%20composition&width=900&height=1200&seq=ev-chat-2026&orientation=portrait',
    dominantType: 'chat',
    summary: '家长公开宣传与沟通聊天记录，称课程宣传含「保录取」承诺；机构回应称系顾问个人违规话术，已启动核查。',
    paragraphs: [
      '事件聚焦一名家长公开的高考志愿填报服务沟通记录。家长称前期宣传多次出现「可保录取、不过退费」等字眼，与事后合同约定的退费条件存在明显差异。',
      '机构随后在公开声明中回应，指相关承诺系个别顾问违规话术，并非官方服务标准，表示已对涉事顾问进行处理，并愿协商退费。',
      '反锤方向在于：家长晒出的宣传物料时间点与顾问在职状态，成为判断责任归属的关键，相关证据仍在补档中。',
    ],
    materials: [
      { type: 'chat', title: '顾问宣传聊天记录', note: '含「保录取」表述的完整聊天截图。', source: '家长提供', time: '2026-07-20', verified: true },
      { type: 'social', title: '机构公开回应声明', note: '官方账号声明截图。', source: '机构官方号', time: '2026-07-28', verified: true },
      { type: 'doc', title: '服务合同与付款凭证', note: '合同金额与付款流水截图。', source: '家长提供', time: '2026-07-22', verified: true },
    ],
    timeline: [
      { time: '2026-07-20', text: '家长发布首段咨询沟通截图。' },
      { time: '2026-07-28', text: '机构发布公开回应，称系个别话术。' },
      { time: '2026-08-02', text: '双方进入协商，本条目标记辟谣中。' },
    ],
    related: ['canyin-pingtai-huishou', 'maifang-yujia-zhongjie'],
  },
  {
    slug: 'shentou-peixun-muwang',
    title: '短视频运营「陪跑」课程割韭菜投诉汇总',
    tagline: '多期学员集中晒转账与承诺截图，官方课程价格成罗生门',
    category: '知识付费',
    status: '持续更新',
    persons: ['多位报课学员'],
    time: '2026-07-19',
    heat: 9.2,
    cover: 'https://readdy.ai/api/search-image?query=vintage%20bank%20transfer%20receipts%20and%20payment%20ledgers%20collage%20on%20warm%20sepia%20paper%2C%20vermilion%20red%20ink%20annotations%2C%20archival%20documentary%20scan%2C%20editorial%20high%20contrast&width=900&height=1200&seq=ev-transfer-2026&orientation=portrait',
    dominantType: 'transfer',
    summary: '多名学员晒出不同金额的转账与宣传截图，质疑课程「保收益」话术与退费难问题，平台方暂未公开处理名单。',
    paragraphs: [
      '本档案汇总多起指向同一家短视频培训机构的投诉。不同学员晒出的转账记录金额从数千到数万元不等，宣传物料中均出现「轻松月入过万」等收益话术。',
      '争议焦点集中在两点：一是宣传与售后承诺的边界，二是退费流程的透明程度。多人表示联系退款后进入长时间等待。',
      '69爆料已按学员、金额、时间建立索引，便于检索比对同一讲师话术是否重复出现，也欢迎更多当事人补充票据以补全时间线。',
    ],
    materials: [
      { type: 'transfer', title: '多笔课程付款转账记录', note: '含转账时间、金额与收款方信息。', source: '多学员提供', time: '2026-06-11', verified: true },
      { type: 'chat', title: '招生话术与退费沟通截图', note: '多名学员晒出的雷同话术。', source: '社媒公开帖', time: '2026-06-25', verified: true },
      { type: 'video', title: '讲师公开课录屏片段', note: '公开课中的收益承诺片段。', source: '平台公开回放', time: '2026-05-30', verified: true },
    ],
    timeline: [
      { time: '2026-05-30', text: '讲师公开课录屏开始在学员群流传。' },
      { time: '2026-06-11', text: '首批学员集中晒出转账记录。' },
      { time: '2026-07-19', text: '新增一期学员证据，形成多批次汇总。' },
    ],
    related: ['xuetang-gaokao-kecheng', 'chuanmei-xiaoguan-huitao'],
  },
  {
    slug: 'maifang-yujia-zhongjie',
    title: '二手房中介「吃差价」交易录音争议',
    tagline: '买家公开电话录音称被两头压价，中介方否认',
    category: '房产消费',
    status: '辟谣中',
    persons: ['购房人(化名)', '某房产中介门店'],
    time: '2026-08-11',
    heat: 8.4,
    cover: 'https://readdy.ai/api/search-image?query=archival%20scan%20of%20audio%20waveform%20printed%20on%20analog%20tape%20paper%2C%20warm%20cream%20background%20with%20vermilion%20marker%2C%20documentary%20high%20contrast%20editorial%20aesthetic&width=900&height=1200&seq=ev-audio-2026&orientation=portrait',
    dominantType: 'audio',
    summary: '购房人公开交易沟通录音，怀疑中介在买卖双方间压价赚取差价；门店称流程合规并已自查。',
    paragraphs: [
      '事件围绕一段购房交易电话录音展开。录音中疑似中介同时与买卖双方沟通，报价存在明显出入，被质疑「两头通吃」。',
      '涉事中介门店回应称交易流程符合规范，买卖价差来自税费与过户成本，并出具了部分费用单据，双方说法进入胶着。',
      '反锤的关键在于费用明细单据是否完整、录音是否经过剪辑，相关原始素材正在按时间核对中，尚不宜下最终结论。',
    ],
    materials: [
      { type: 'audio', title: '电话沟通录音(片段)', note: '涉及向买卖双方报价的核心片段。', source: '购房人提供', time: '2026-07-15', verified: true },
      { type: 'doc', title: '中介费用明细单据', note: '门店回应的费用构成说明。', source: '门店公开回应', time: '2026-08-05', verified: false },
      { type: 'transfer', title: '定金与尾款转账记录', note: '购房付款流水截图。', source: '购房人提供', time: '2026-07-12', verified: true },
    ],
    timeline: [
      { time: '2026-07-12', text: '完成签约与首笔付款。' },
      { time: '2026-07-15', text: '购房人整理出录音片段并发帖。' },
      { time: '2026-08-05', text: '中介门店公开费用明细回应。' },
      { time: '2026-08-11', text: '双方说法胶着，标记为辟谣中。' },
    ],
    related: ['canyin-pingtai-huishou', 'xuetang-gaokao-kecheng'],
  },
  {
    slug: 'chuanmei-xiaoguan-huitao',
    title: '网络红人「卖惨直播」收益与捐款去向调查',
    tagline: '网友比对打赏榜与公益账号，质疑捐款未达公开金额',
    category: '公益直播',
    status: '辟谣中',
    persons: ['某公益主播'],
    time: '2026-07-05',
    heat: 9.0,
    cover: 'https://readdy.ai/api/search-image?query=abstract%20film%20strip%20frames%20and%20retro%20camera%20archive%20collage%20on%20warm%20cream%20paper%2C%20vermilion%20red%20tint%2C%20documentary%20editorial%20aesthetic%2C%20high%20contrast&width=900&height=1200&seq=ev-video-2026&orientation=portrait',
    dominantType: 'video',
    summary: '有网友整理多场直播收益截图与公益账号明细，质疑捐款总额与直播打赏存在出入，主播方晒出打款凭证回应。',
    paragraphs: [
      '事件源于一名公益主播多场「卖惨」直播。网友将直播间的打赏榜单截图与公开的公益账号收款明细并列比对，认为到账金额与宣称的捐款数额存在落差。',
      '主播方随后晒出部分公益机构的打款回执，称部分捐款以现金与物资形式落地，未全部走公开账号，解释引发新一轮讨论。',
      '本档案在反锤方向收集了打款回执、机构回复与网友整理的对照表，把双方材料并列陈列，等待平台或第三方出具完整流水后推进。',
    ],
    materials: [
      { type: 'video', title: '多场直播打赏榜单录屏', note: '网友录制的打赏榜与在看人数画面。', source: '网友录制', time: '2026-06-28', verified: true },
      { type: 'transfer', title: '公益账号收款明细', note: '公开捐款账号的流水截图。', source: '网友整理', time: '2026-07-01', verified: true },
      { type: 'doc', title: '公益机构打款回执', note: '主播晒出的机构回执照片。', source: '主播公开回应', time: '2026-07-03', verified: false },
    ],
    timeline: [
      { time: '2026-06-28', text: '网友开始录制直播收益画面。' },
      { time: '2026-07-01', text: '收益截图与公益账号明细被对照整理。' },
      { time: '2026-07-03', text: '主播晒出打款回执回应。' },
      { time: '2026-07-05', text: '双方材料并列，条目进入辟谣中。' },
    ],
    related: ['shentou-peixun-muwang', 'gongyi-huimao-yingpian'],
  },
  {
    slug: 'gongyi-huimao-yingpian',
    title: '公益宣传影片素材「摆拍造假」指控',
    tagline: '网友逐帧比对影片背景与现场，质疑并非真实记录',
    category: '公益造假',
    status: '已辟谣',
    persons: ['某公益组织'],
    time: '2026-06-16',
    heat: 8.1,
    cover: 'https://readdy.ai/api/search-image?query=newspaper%20clipping%20archive%20collage%20with%20red%20rubber%20stamp%20seals%20on%20warm%20paper%2C%20documentary%20documentation%20aesthetic%2C%20high%20contrast%20editorial%20scan&width=900&height=1200&seq=ev-doc2-2026&orientation=portrait',
    dominantType: 'video',
    summary: '公益影片被网友质疑为摆拍，官方出示完整拍摄花絮与场地证明后，指控基本澄清。',
    paragraphs: [
      '一段公益宣传影片播出后，有网友发现片中多个场景的背景与另一场活动的现场照高度相似，怀疑影片以旧素材或摆拍冒充真实记录。',
      '涉事公益组织随后放出未剪辑的花絮与场地方出具的借用证明，说明影片采用情景再现手法并在画面角落做了标注，解释了背景相似的原因。',
      '经多方比对，原指控中的「造假」多为误读。本档案作为「已辟谣」样本保留，以展示站内反锤与证据对质的完整流程。',
    ],
    materials: [
      { type: 'video', title: '公益宣传影片原始片段', note: '被质疑的影片段落。', source: '官方发布', time: '2026-06-08', verified: true },
      { type: 'doc', title: '场地方借用证明', note: '场地管理方出具的说明。', source: '公益组织回应', time: '2026-06-12', verified: true },
      { type: 'social', title: '网友逐帧比对帖', note: '含背景重叠标注的图文分析。', source: '吃瓜社区', time: '2026-06-10', verified: false },
    ],
    timeline: [
      { time: '2026-06-08', text: '影片发布后引发比对讨论。' },
      { time: '2026-06-10', text: '网友制作背景逐帧比对帖。' },
      { time: '2026-06-12', text: '组织方出示花絮与场地证明。' },
      { time: '2026-06-16', text: '指控基本澄清，标记已辟谣。' },
    ],
    related: ['chuanmei-xiaoguan-huitao', 'jiuye-peixun-qiye'],
  },
  {
    slug: 'jiuye-peixun-qiye',
    title: '「保就业」内推培训退费与岗位数量争议',
    tagline: '多起投诉指向同一位「就业导师」，岗位承诺难兑现',
    category: '职场培训',
    status: '持续更新',
    persons: ['多位求职者'],
    time: '2026-05-23',
    heat: 8.6,
    cover: 'https://readdy.ai/api/search-image?query=stacked%20payment%20receipts%20and%20resume%20documents%20on%20warm%20paper%2C%20vermilion%20red%20stamp%20marks%2C%20archival%20recruitment%20documentary%20aesthetic%2C%20editorial%20high%20contrast&width=900&height=1200&seq=ev-transfer2-2026&orientation=portrait',
    dominantType: 'doc',
    summary: '多名求职者称「保内推就业」课程承诺的岗位并未兑现，晒出聊天与合同要求退费，涉事导师账号已改名。',
    paragraphs: [
      '本档案关联多位报名「保就业」内推课程的求职者。他们晒出雷同的招生聊天记录与合同，称课程结束后承诺的内推岗位迟迟未兑现，申请退费被以各种理由拖延。',
      '有网友发现涉事「就业导师」账号近期改名并清空历史动态，引发更多人加入举证，目前相关投诉数量仍在上升。',
      '站内已按报名批次与金额整理索引，便于后来的当事人判断自己属于哪一批次，也用于比对宣传话术是否重复出现。',
    ],
    materials: [
      { type: 'chat', title: '招生与内推承诺聊天记录', note: '多位求职者晒出的雷同话术。', source: '求职者提供', time: '2026-04-18', verified: true },
      { type: 'transfer', title: '课程付款与退费沟通记录', note: '付款流水与退费拖延沟通截图。', source: '求职者提供', time: '2026-05-02', verified: true },
      { type: 'social', title: '导师账号改名时间线', note: '网友记录的账号状态变化。', source: '网友整理', time: '2026-05-20', verified: false },
    ],
    timeline: [
      { time: '2026-04-18', text: '首批学员公开内推承诺聊天截图。' },
      { time: '2026-05-02', text: '退费难问题引发集中反馈。' },
      { time: '2026-05-20', text: '导师账号改名，证据持续补档。' },
      { time: '2026-05-23', text: '形成多批次投诉汇总条目。' },
    ],
    related: ['shentou-peixun-muwang', 'canyin-pingtai-huishou'],
  },
  {
    slug: 'lvxingtuan-tuiqian',
    title: '低价旅行团「强制购物」录音与退费拉锯',
    tagline: '团员公开现场录音称被带去购物点，旅行社称自愿',
    category: '旅游消费',
    status: '持续更新',
    persons: ['多位跟团游客', '某旅行社'],
    time: '2026-09-01',
    heat: 8.8,
    cover: 'https://readdy.ai/api/search-image?query=archival%20travel%20ticket%20and%20recording%20waveform%20on%20warm%20paper%2C%20map%20lines%20and%20vermilion%20stamp%2C%20documentary%20editorial%20aesthetic%2C%20high%20contrast&width=900&height=1200&seq=ev-audio2-2026&orientation=portrait',
    dominantType: 'audio',
    summary: '跟团游客公开多段现场录音，指被导游带往强制购物点停留数小时；旅行社回应称系自愿行程安排。',
    paragraphs: [
      '事件发生于一条被标注「纯玩」的低价旅行线路。多名团员晒出现场录音，称在导游安排下于指定购物点停留数小时，若不消费导游语言冷嘲热讽。',
      '涉事旅行社回应称该购物点为可选行程，团员下单时已勾选同意，并出示了报名时的协议勾选项截图。',
      '反锤焦点在报名协议勾选是否显著提示、现场是否存在强制停留，双方各执一词，相关行程单与录音仍在补档。',
    ],
    materials: [
      { type: 'audio', title: '购物点现场录音', note: '多段现场对话录音。', source: '团员提供', time: '2026-08-26', verified: true },
      { type: 'doc', title: '报名协议勾选截图', note: '旅行社出示的协议勾选项。', source: '旅行社回应', time: '2026-08-30', verified: false },
      { type: 'chat', title: '退费沟通聊天记录', note: '团员与客服的退费交涉过程。', source: '团员提供', time: '2026-08-28', verified: true },
    ],
    timeline: [
      { time: '2026-08-26', text: '团员在团内公开现场录音。' },
      { time: '2026-08-28', text: '退费交涉未果，证据开始外传。' },
      { time: '2026-08-30', text: '旅行社晒出报名协议回应。' },
      { time: '2026-09-01', text: '双方说法并列，条目进入持续更新。' },
    ],
    related: ['canyin-pingtai-huishou', 'gongyi-huimao-yingpian'],
  },
];

export const faqs: FaqItem[] = [
  {
    q: '什么是「实锤」和「石锤」？',
    a: '站内「实锤 / 石锤」均指已经过整理、来源相对清晰、可供多方交叉核验的公开材料，例如原始聊天截图、转账流水、录音文件等。需要说明的是，「实锤」是站内档案的整理标签，不代表对事件的最终定性，请以当事方正式声明与监管结论为准。',
  },
  {
    q: '你们和普通吃瓜号有什么区别？',
    a: '69爆料不做情绪化剪辑与站队，只做「材料归拢 + 标注来源 + 记录时间线」。每一条爆料都尽量写明素材类型、提供方与补档时间，方便你自行比对，而不是只丢给你一个带节奏的结论。',
  },
  {
    q: '一份证据补档后为什么还要再更新？',
    a: '吃瓜事件是动态的，双方往往后续会回应、晒出新材料甚至反转。所以站内条目会随新素材不断补档，并如实标记「持续更新 / 辟谣中 / 已辟谣」等状态，而不是发完一次就定型。',
  },
  {
    q: '「辟谣反锤」是怎么运作的？',
    a: '当事件另一方晒出反驳材料时，我们会把正反两方证据并列陈列，并补充来源与时间对照，交由你自行判断真伪。站内不预设立场，但会优先收录能提供原始出处或第三方凭证的反驳信息。',
  },
  {
    q: '如何判断素材是不是被剪辑过？',
    a: '本站在收录时仅对明显的敏感信息做脱敏，不改变内容时序。但仍建议你关注素材是否包含首尾完整的上下文、时间戳与平台水印，并尽量与官方原始发布交叉比对。任何脱离上下文的片段都应审慎看待。',
  },
  {
    q: '如何向我投稿或补充证据？',
    a: '你可以在「我要投稿」中留下线索，或通过页脚邮箱与我们联系。为保证档案可信度，投稿素材需尽可能提供可公开的来源与时间信息，我们会先核对再决定是否补档，并保留对涉及隐私、侵权内容的把关权利。',
  },
];